
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regions/[regionId]",
      function () {
        return require("private-next-pages/regions/[regionId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regions/[regionId]"])
      });
    }
  